export interface AvatarOption {
  id: string;
  name: string;
  emoji: string;
  bg: string;
}

export const AVATARS: AvatarOption[] = [
  { id: 'explorer', name: 'Explorer', emoji: '🧭', bg: 'bg-teal-100' },
  { id: 'scholar', name: 'Scholar', emoji: '📚', bg: 'bg-blue-100' },
  { id: 'creator', name: 'Creator', emoji: '🎨', bg: 'bg-purple-100' },
  { id: 'athlete', name: 'Athlete', emoji: '🏅', bg: 'bg-orange-100' },
  { id: 'foodie', name: 'Foodie', emoji: '🍳', bg: 'bg-red-100' },
  { id: 'traveler', name: 'Traveler', emoji: '✈️', bg: 'bg-yellow-100' },
  { id: 'gamer', name: 'Gamer', emoji: '🎮', bg: 'bg-indigo-100' },
  { id: 'nature', name: 'Nature', emoji: '🌿', bg: 'bg-green-100' },
];

export function getAvatar(avatarId: string | null | undefined): AvatarOption | null {
  if (!avatarId) return null;
  return AVATARS.find((a) => a.id === avatarId) ?? null;
}
